import styled from "styled-components";

import { colors } from "shared/ui/tokens";

import { MOBILE_BREAKPOINT } from "features/IikoIntegration/constants";

export const Container = styled.div`
    max-width: 1128px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-bottom: 28px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        gap: 16px;
    }
`;

// Шапка контента: кнопка «назад» и подпись меню. Заголовок страницы живёт в шапке приложения.
export const ContentHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        gap: 12px;
    }
`;

export const ContentHeaderCaption = styled.div`
    min-width: 0;
    font-size: 0.9375rem;
    color: ${colors.textSecondary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

// Будущий шаг: карточка на месте, но приглушена — видно, что откроется дальше.
export const Muted = styled.div`
    opacity: 0.45;
    pointer-events: none;
`;
